// extracted by mini-css-extract-plugin
export var container = "_7z-0";
export var error = "_7z-9";
export var label = "_7z-5";
export var light = "_7z-6";
export var md = "_7z-3";
export var sm = "_7z-2";
export var thin = "_7z-8";
export var thinBold = "_7z-7";
export var vertical = "_7z-4";
export var xs = "_7z-1";